import { render, staticRenderFns } from "./VRecentData.vue?vue&type=template&id=6f6d767d&"
import script from "./VRecentData.vue?vue&type=script&lang=js&"
export * from "./VRecentData.vue?vue&type=script&lang=js&"
import style0 from "./VRecentData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports